import TerminalStatusCard from "./TerminalStatusCard";
import { styled } from "@mui/system";
import Box from "@material-ui/core/Box";
//import ButtonMUI from "@mui/material/Button";
import { TerminalStatusLogEntry, TerminalStatusLogInfo } from "../gateways/cms/log";
import { useGetMyUserQuery } from "../gateways/cms/userApi";

// style
const GroupList = styled("section")`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
    padding: 0 24px;
`;
const GroupBox = styled(Box)`
    position: relative;
    width:calc(100% / 5 - 10px);
    min-width:250px;
    height: 445px;
    margin: 0 10px 10px 0;

    & > .MuiButton-root {
        position: absolute;
        right: 8px;
        top: 8px;
        z-index: 1;
        opacity: 0;
        pointer-events: none;
    }
    &:hover > .MuiButton-root {
        opacity: 1;
        pointer-events: unset;
    }
`;
const GroupUserBox = styled(Box)`
    position: relative;
    width:calc(100% / 5 - 10px);
    min-width:250px;
    height: 405px;
    margin: 0 10px 10px 0;

    & > .MuiButton-root {
        position: absolute;
        right: 8px;
        top: 8px;
        z-index: 1;
        opacity: 0;
        pointer-events: none;
    }
    &:hover > .MuiButton-root {
        opacity: 1;
        pointer-events: unset;
    }
`;
/** タスク追加 無効のためコメントアウト
const GroupButton = styled(ButtonMUI)`
    &,
    &.MuiButton-contained {
        height: 24px;
        width: 80px;
        border-radius: 2px;
        font-size: 12px;
        padding: 0;
    }
`;
** コメントアウトここまで **/

export interface Props {
    entry: TerminalStatusLogEntry;
}

export function OrganizationTerminalStatusLog({ entry }: Props) {
    // ユーザー情報取得
    const user = useGetMyUserQuery();
    if (!user.data) {
        return <div></div>;
    };

    return (
        
        <GroupList>
            {user.data?.checkAdmin ?  
                (entry.organization.terminals.map((terminal) => (
                    <GroupBox key={entry.organization.id}>
                        <TerminalStatusCard
                            title={terminal.name}
                            subheader={terminal.location}
//                            location={terminal.location}
                            message={terminal.info.message}
                            memo={terminal.memo}
                            background={convertErrorLevel(terminal.info, terminal.powerStatus)}
                            screenShot={terminal.info.screenShot}
                            image={terminal.info.screenshotUri}
                            datetime={terminal.info.updatedAt}
                            organizationId={entry.organization.id}
                            terminalId={terminal.id}
                            powerStatus={terminal.powerStatus}
                            checkAdmin={true}
                            hasAttachments={terminal.hasAttachments}
                        />
                    </GroupBox>
            ))):
                (entry.organization.terminals.map((terminal) => (
                    <GroupUserBox  key={entry.organization.id}>
                        <TerminalStatusCard
                            title={terminal.name}
                            subheader={terminal.location}
//                            location={terminal.location}
                            message={terminal.info.message}
                            memo={terminal.memo}
                            background={convertErrorLevel(terminal.info, terminal.powerStatus)}
                            screenShot={terminal.info.screenShot}
                            image={terminal.info.screenshotUri}
                            datetime={terminal.info.updatedAt}
                            organizationId={entry.organization.id}
                            terminalId={terminal.id}
                            powerStatus={terminal.powerStatus}
                            checkAdmin={false}
                            hasAttachments={terminal.hasAttachments}
                        />
                    </GroupUserBox>
            )))}
        </GroupList>
    );
}

function convertErrorLevel(info:TerminalStatusLogInfo, powerStatus:boolean): 
    "unopened" | "uncontrolled" | "error" | "monitor_warning" | "null_normal" | "null_warning" | "normal" | "off" |  "db_error"  {
    // 未稼働の場合
    if(info.displayStatus === "Unopened") return "unopened"
    // エラーの場合
    switch (info.errorUpdate) {
        case "error":
        case "Error":
            // 制御エラー
            return "error";
        case "db_error":
            // DBエラー
            return "db_error";
    }
    // モニター非制御の場合
    if(info.displayStatus === "Uncontrolled") return "uncontrolled"
    // NULLの場合
    if(info.displayStatus === "NULL"){
        if(info.nullTimes < 5){
            return "null_normal";
        }
        else{
            return "null_warning";
        }
    }
    // ONスケジュールの場合
    if(powerStatus){
        if(info.displayStatus === "On"){
            // 正常
            return "normal";
        }
        else{
            // モニター制御エラー
            return "monitor_warning";
        }
    }
    // OFFスケジュールの場合
    else{
        if(info.displayStatus === "Off"){
            // 正常
            return "normal";
        }
        else{
            // モニター制御エラー
            return "monitor_warning";
        }
    }
}
